import { FormError } from '../../../types/common.types'
import { SystemUser, UserSessionType } from '../../../types'
import { handleGetIfEmailIsValid } from '../../../utils/common.utils'

export const handleValidateSystemUserFormData = (systemUserData: SystemUser, systemUsersData: Array<SystemUser>, userSession: UserSessionType, actionToDo: string, t: (value: string) => string) => {
  let formDataIsValid = true
  const formErrors: FormError = {}
  const isEmail = handleGetIfEmailIsValid(systemUserData.username || '')
  const userAlreadyExists = systemUsersData.find((currentSystemUserData) => currentSystemUserData.username === systemUserData.username)
  const isSameUser = systemUserData.username === userSession?.username

  if (systemUserData.firstName === '') {
    formDataIsValid = false
    formErrors.firstName = t('newSystemUserModal.systemUserDataForm.errors.emptyFirstName')
  }

  if (systemUserData.lastName === '') {
    formDataIsValid = false
    formErrors.lastName = t('newSystemUserModal.systemUserDataForm.errors.emptyLastName')
  }

  if (systemUserData.username === '') {
    formDataIsValid = false
    formErrors.username = t('newSystemUserModal.systemUserDataForm.errors.emptyUsername')
  }

  if (systemUserData.username !== '' && !isEmail) {
    formDataIsValid = false
    formErrors.username = t('newSystemUserModal.systemUserDataForm.errors.invalidUsername')
  }

  if (systemUserData.username !== '' && isSameUser) {
    formDataIsValid = false
    formErrors.username = t('newSystemUserModal.systemUserDataForm.errors.duplicateUsername')
  }

  if (systemUserData.username !== '' && !isSameUser && actionToDo === 'create' && userAlreadyExists) {
    formDataIsValid = false
    formErrors.username = t('newSystemUserModal.systemUserDataForm.errors.duplicateUsername')
  }

  if (systemUserData.role === '') {
    formDataIsValid = false
    formErrors.role = t('newSystemUserModal.systemUserDataForm.errors.emptyUserRole')
  }

  return { formDataIsValid, formErrors }
}
